module.exports = __webpack_public_path__ + "static/media/academic_icon.9b559f96.png";